import React from "react";

function SvgLoanRepayment({
  color = "currentColor",
  width = 18,
  height = 20,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      {...props}
    >
      <path
        d="M9 9C8.16667 9 7.45833 8.70833 6.875 8.125C6.29167 7.54167 6 6.83333 6 6C6 5.16667 6.29167 4.45833 6.875 3.875C7.45833 3.29167 8.16667 3 9 3C9.83333 3 10.5417 3.29167 11.125 3.875C11.7083 4.45833 12 5.16667 12 6C12 6.83333 11.7083 7.54167 11.125 8.125C10.5417 8.70833 9.83333 9 9 9ZM2 12C1.45 12 0.979167 11.8042 0.5875 11.4125C0.195833 11.0208 0 10.55 0 10V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V10C18 10.55 17.8042 11.0208 17.4125 11.4125C17.0208 11.8042 16.55 12 16 12H2ZM4 10H14C14 9.45 14.1958 8.97917 14.5875 8.5875C14.9792 8.19583 15.45 8 16 8V4C15.45 4 14.9792 3.80417 14.5875 3.4125C14.1958 3.02083 14 2.55 14 2H4C4 2.55 3.80417 3.02083 3.4125 3.4125C3.02083 3.80417 2.55 4 2 4V8C2.55 8 3.02083 8.19583 3.4125 8.5875C3.80417 8.97917 4 9.45 4 10ZM9 20L13 16L11.6 14.6L10 16.2V13H8V16.2L6.4 14.6L5 16L9 20Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgLoanRepayment;
